<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
<div >
    <div class="d-flex whitesmoke">
        <v-subheader class="justify-space-between subtitle-1 whitesmoke font-weight-medium grayBold--text">
          {{ $t("boiler_faults_history") }}
        </v-subheader>
    </div>
    <v-list class="whitesmoke tab" min-width="500px">
                <v-data-table :headers="tableheaders" :items="deviceFaultData" 
          fixed-header max-height="450px" item-key="tagId" class="installation-table max-height elevation-1"
         >
          <template v-slot:[`item.time`]="{item}">
            {{ formatDate(item.time)}}
          </template>
          <template v-slot:[`item.oem`]="{item}">
            {{ faultMapping(item.oem).code}}
          </template>
          <template v-slot:[`item.description`]="{item}">
            <v-tooltip color="gray" v-if="faultMapping(item.oem).description" light class="pt-1 grayBold--text text-truncate" max-width="350px" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="textColor"
                dark
                v-bind="attrs"
                v-on="on"
              >
                mdi-information-outline
              </v-icon>
            </template>
            <span>{{ faultMapping(item.oem).description}}</span>
          </v-tooltip>
          </template>
          <template v-slot:no-data>
            {{ $t("no_faults_found") }}
          </template>
        </v-data-table>
    </v-list>
    </div>
</template>


<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { TimeUtil } from '@/helpers/TimeUtil'
import { devicesModule } from '@/store/modules/store-accessor'
import riello_fault_mapping from "@/assets/fault_mapping/RIELLO.json";

@Component
export default class DevicesSideviewFaultsTab extends Vue {
 @Prop() device: Record<string, any>;
  
  currentLanguage = localStorage.getItem("lang") || "el";
  tableheaders: any [] = [
    {
      text: this.$t("date"),
      align: 'left',
      class: 'row-style',
      sortable: true,
      value: 'time'
    },
    { text: this.$t("fault"), sortable: true, class: 'row-style', value: 'oem' },
    { text: '', sortable: false, class: 'row-style', value: 'description' },
  ]

  deviceFaultData = []

  async mounted() {
      this.deviceFaultData = await devicesModule.getDeviceFaultHistory(this.device.info.device_id);
  }
  
  formatDate (date: string): string {
    return TimeUtil.formatInfluxDate(date)
  }

  get faultMap() {
    return this.device.info.hvac_error_mapping_json as any || {}; 
  }

  //Format Error Codes here?
  faultMapping(code: string): any {
    if(this.device.info.device_type == 'DOMX_HC_MB') {
      // create the JSON for the Riello mapping and use it to translate. 
      return {"code": this.faultMap[code].code ?? code , "description": this.faultMap[code].description[this.currentLanguage] }
    }

    return {"code": code };
  }
};
</script>

<style scoped lang="scss">
.tab {
  max-height: calc(80vh) !important;
  overflow-y: auto;
}

div { 
    width:100%;
}

.expansion-item {
  display: block;
  width: 50px;
  word-wrap: break-word;
}

.is_disabled {
  color: #b9b9b9!important;
  background-color:#e6e6e6;

}
</style>
